import { createStyles, withStyles } from '@mui/styles';
import React, { Component } from 'react';
import { GridSortModel, GridSortDirection, GridSortItem, GridColumnVisibilityModel } from '@mui/x-data-grid';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Theme, Grid, Paper, Container } from '@mui/material';
import UrlConstants from '../../../constants/UrlConstants';
import { RootState } from '../../../setup';
import Pagination from '../../../interfaces/common/pagination';
import Paging from '../../../interfaces/common/paging';
import IMenuItem from '../../../interfaces/common/menuItem';
import MainLayout from '../../common/widgets/mainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FactorSetsFiltersComponent from './../factorSetsFiltersComponent';
import { fetchFactorSetDangerousGoods, getFactorSetDangerousGoods, isLoadingFactorSetDangerousGoods } from '../../../reducers/factorSetDangerousGoodsReducer';
import FactorSetOut from '../../../interfaces/output/factorSetOut';
import LanguageUtils from '../../../utils/LanguageUtils';
import QuickSearchToolbar from '../../common/quickSearchToolbar';
import PageUtils from '../../../utils/pageUtils';
import DangerousGoodsList from './dangerousGoodsList';
import DangerousGoodsFilter from './dangerousGoodsFilter';

interface IFactorSetDangerousGoodsProps {
    factorSetDangerousGoods: Pagination<FactorSetOut>;
    classes: any;
    fetchFactorSetDangerousGoods: any;
    isLoading: boolean;
    onChange: () => void;
}

interface IFactorSetDangerousGoodsState {
    searchTerm: string;
    paging: Paging;
    menuItem: IMenuItem;
    sortModel: GridSortModel;
    filters: DangerousGoodsFilter;
    columnVisibilityModel: GridColumnVisibilityModel;
}

const messages = {
    factorSetDangerousGoods: LanguageUtils.createMessage('Factor set dangerous goods'),
    add: LanguageUtils.createMessage('Add')
};

const styles = (theme: Theme) => createStyles({
    container: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    paper: {
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column'
    }
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchFactorSetDangerousGoods: (paging: Paging, filters: DangerousGoodsFilter) => dispatch(fetchFactorSetDangerousGoods({
        paging,
        filters
    }))
});

const mapStoreToProps = (store: RootState) => {
    return {
        factorSetDangerousGoods: getFactorSetDangerousGoods(store),
        isLoading: isLoadingFactorSetDangerousGoods(store)
    };
};

class FactorSetDangerousGoods extends Component<IFactorSetDangerousGoodsProps, IFactorSetDangerousGoodsState> {
    dangerousGoodsListRef: any;
    constructor(props: IFactorSetDangerousGoodsProps) {
        super(props);
        this.dangerousGoodsListRef = React.createRef();

        this.state = {
            searchTerm: '',
            paging: PageUtils.getDefaultPaging(),
            filters: {
                name: ''
                // default: true
            } as DangerousGoodsFilter,
            menuItem: {
                id: 1,
                name: messages.factorSetDangerousGoods,
                icon: <FontAwesomeIcon icon="calendar-check" size="1x" transform="grow-7" />,
                isSelected: false
            },
            sortModel: [{
                field: '',
                sort: '' as GridSortDirection
            } as GridSortItem],
            columnVisibilityModel: {}
        };
    }

    componentDidMount() {
        const { fetchFactorSetDangerousGoods } = this.props;
        const { paging, filters } = this.state;

        fetchFactorSetDangerousGoods(paging, filters);
    }

    onChange = (attribute: string, value: any) => {
        const { filters, paging } = this.state;

        const newFilter = { ...filters } as DangerousGoodsFilter;
        (newFilter as any)[attribute] = value;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page
        };

        this.setState({
            filters: newFilter,
            paging: newPagination
        });
    }

    applyFilters = () => {
        const { fetchFactorSetDangerousGoods } = this.props;
        const { paging, filters } = this.state;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page
        };
        this.setState({
            paging: newPagination
        });

        fetchFactorSetDangerousGoods(newPagination, filters);

        if(this.dangerousGoodsListRef !== null && this.dangerousGoodsListRef !== undefined &&
            this.dangerousGoodsListRef.current !== null && this.dangerousGoodsListRef.current !== undefined) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.dangerousGoodsListRef.current.resetDataGridPage();
        }
    }

    setDefaultState = () => {
        const { fetchFactorSetDangerousGoods } = this.props;
        const { paging } = this.state;

        const newFilters = {
            name: ''
            // default: true
        } as DangerousGoodsFilter;

        const newSortModel = [{
            field: 'name',
            sort: 'asc'
        }] as GridSortModel;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page,
            sort: newSortModel
        };

        this.setState({
            paging: newPagination,
            filters: newFilters,
            searchTerm: ''
        });

        fetchFactorSetDangerousGoods(newPagination, newFilters);

        if(this.dangerousGoodsListRef !== null && this.dangerousGoodsListRef !== undefined &&
            this.dangerousGoodsListRef.current !== null && this.dangerousGoodsListRef.current !== undefined) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.dangerousGoodsListRef.current.resetDataGridPage();
        }
    }

    onChangeQuickSearch = (value: any) => {
        const { filters, paging } = this.state;
        const { fetchFactorSetDangerousGoods } = this.props;

        const newFilter = { ...filters } as DangerousGoodsFilter;
        (newFilter as any)['name'] = value;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page
        };

        this.setState({
            filters: newFilter,
            paging: newPagination,
            searchTerm: value
        });

        fetchFactorSetDangerousGoods(newPagination, newFilter);
    }

    _onSortChange = (newModel: GridSortModel) => {
        const { fetchFactorSetDangerousGoods } = this.props;
        const { sortModel, filters, paging } = this.state;

        if(JSON.stringify(sortModel) !== JSON.stringify(newModel)) {
            const newPagination = {
                ...paging,
                sort: newModel
            };
            this.setState({
                sortModel: newModel,
                paging: newPagination
            });

            fetchFactorSetDangerousGoods(newPagination, filters);
        }
    }

    render() {
        const { classes, factorSetDangerousGoods, fetchFactorSetDangerousGoods, isLoading } = this.props;
        const { searchTerm, paging, filters, menuItem, columnVisibilityModel } = this.state;

        return (
            <MainLayout menuItem={menuItem}>
                <Container maxWidth="xl" className={classes.container}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Paper className={classes.paper}>
                                <QuickSearchToolbar
                                    onSearch={this.onChangeQuickSearch}
                                    searchTerm={searchTerm}
                                    includeFilters={true}
                                    actions={[{
                                        text: messages.add,
                                        icon: 'plus',
                                        href: `${UrlConstants.FACTOR_SETS}/dangerousgoods/add`
                                    }]}
                                >
                                    <FactorSetsFiltersComponent applyFilters={this.applyFilters} setDefaultState={this.setDefaultState} filters={filters} onChange={this.onChange} />
                                </QuickSearchToolbar>
                                <DangerousGoodsList rows={factorSetDangerousGoods} isLoading={isLoading}
                                    ref={this.dangerousGoodsListRef}
                                    onPageChange={(nextPage: number, nextSize: number) => {
                                        const newPage = {
                                            ...paging,
                                            page: nextPage,
                                            size: nextSize
                                        };
                                        fetchFactorSetDangerousGoods(newPage, filters);
                                        this.setState({ paging: newPage });
                                    }}
                                    onSortModelChange={(sortModel: GridSortModel) => this._onSortChange(sortModel)}
                                    columnVisibilityModel={columnVisibilityModel}
                                    onColumnVisibilityModelChange={(newModel : GridColumnVisibilityModel) =>
                                        this.setState({
                                            columnVisibilityModel: newModel
                                        })
                                    }
                                />
                            </Paper>
                        </Grid>
                    </Grid>
                </Container>
            </MainLayout>
        );
    }
}

export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(FactorSetDangerousGoods));